import Image from 'next/image';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import { getCurrentCountry } from './constants';
import settings from '@/settings';
import CountrySelectorDropdown from './CountrySelectorDropdown';

const StoreSelector = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const triggerRef = useRef<HTMLButtonElement>(null);
  const selectedStore = getCurrentCountry(settings.store);

  if (selectedStore == null) {
    return null;
  }

  const locale = router.locale || 'en';

  return (
    <div className="relative hidden lg:block">
      <button
        ref={triggerRef}
        type="button"
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="fancy-underline flex items-center gap-2 border-r pr-6 text-sm font-medium"
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="h-6 w-6">
          <Image
            src={selectedStore.flag}
            alt={selectedStore.country}
            width={24}
            height={24}
            className="h-full w-full object-contain"
          />
        </div>
        {locale.toUpperCase()}
      </button>
      <CountrySelectorDropdown
        open={open}
        setOpen={setOpen}
        triggerRef={triggerRef}
      />
    </div>
  );
};

export default StoreSelector;
